//DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent
import { Component, EventEmitter, OnInit, AfterViewInit, Input, Output, Pipe, PipeTransform, HostListener } from '@angular/core';
import { NgModule } from '@angular/core';
//import { ViewChild, ElementRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SocoHttpService } from '@soco/http';
import { DBTraceLogService } from '../../services/dbTraceLog/dbTraceLog.service';
import { CoolEmailService } from '../../services/coolEmail/coolEmail.service';
import { AppointmentConfirmationInput, AppointmentConfirmationOutput } from '../../components/appointmentconfirmation/appointment-confirmation-entities';
import { AppCommonService } from '../../services/common/app-common.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DBTraceLog, LogType } from '../../services/dbTraceLog/dbTraceLog-entities';
import { AppConfigurationData } from '../../services/common/app-common-entities';
import { AppBaseComponent } from '../base/app-base.component';

@Component({
    selector: 'appointment-confirmation',
    templateUrl: 'appointment-confirmation.component.html',
    styleUrls: ['appointment-confirmation.component.css'],
    providers: [DatePipe, DBTraceLogService, AppCommonService]
})
export class AppointmentConfirmationComponent extends AppBaseComponent implements OnInit {

    //#region Variables
    public ldc: string = '';   
    public orderNumber: string = '';
    public premiseNumber: string = '';   
    public urlCode: string;
    public errorInfo: any;    
    public orderType: string = '';
    public personID: string = '';    
    public appConfigurationDataList: Array<AppConfigurationData> = [];        
    public deviceInfo = null;
    public dbTraceLog: DBTraceLog;
    public logReferenceID: string = '';    
    public portalTypeID: number = 0;    
    public appointmentConfirmationOutput: AppointmentConfirmationOutput;
    public emailToList: string;
    public specialFeeMsg: string = '';
    public selectedTimeSlot: string = '';
    public selectedTimeSlotWindow: string = '';
    public entranceInstructionsList: string[] = [];
   
    @Input() appointmentConfirmationInput: AppointmentConfirmationInput;
    //@Output() appointmentConfirmationOutputEvent = new EventEmitter<AppointmentConfirmationOutput>();
    @Output() processErrorEvent = new EventEmitter();

    //#endregion

    constructor(public datepipe: DatePipe, public http: SocoHttpService,
        public dbTraceLogService: DBTraceLogService,
        public deviceService: DeviceDetectorService,
        public coolEmailService: CoolEmailService,
        private appCommonService: AppCommonService) {

        //Parent component initialization
        super(http, dbTraceLogService, coolEmailService, deviceService);
        
        this.appointmentConfirmationOutput = new AppointmentConfirmationOutput();
    };


    ngOnInit() {
        try {
            //Get appt confirmation input from parent
            this.GetAppointmentConfimationInput();

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while loading ngOnInit, Error: ' + e.message.substring(0, 500));
        }

    }      
    
    // #region Helper Methods
    
    private insertDBTraceLog(logType: string, logMessage: string) {

        this.dbTraceLog = new DBTraceLog();

        this.dbTraceLog.portalTypeID = this.portalTypeID; //From parent
        this.dbTraceLog.ldc = this.ldc;
        this.dbTraceLog.kmiUrlCode = this.urlCode;
        this.dbTraceLog.issuingApOrderID = this.orderNumber;
        this.dbTraceLog.orderType = this.orderType;
        this.dbTraceLog.logReferenceID = this.logReferenceID;
        this.dbTraceLog.logType = logType;
        this.dbTraceLog.logMessage = logMessage;
        this.dbTraceLog.emailToList = this.emailToList;

        super.InsertDBTraceLogThruBase(this.dbTraceLog);
    }

    processError(): void {
        this.processErrorEvent.emit();
    }

    private GetAppointmentConfimationInput() {

        this.selectedTimeSlot = this.appointmentConfirmationInput.selectedTimeSlot;
        this.selectedTimeSlotWindow = this.appointmentConfirmationInput.selectedTimeSlotWindow;
        this.entranceInstructionsList = this.appointmentConfirmationInput.entranceInstructionsList; 
        this.specialFeeMsg = this.appointmentConfirmationInput.specialFeeMsg;
        this.emailToList = this.appointmentConfirmationInput.emailToList;
        this.ldc = this.appointmentConfirmationInput.ldc;
        this.logReferenceID = this.appointmentConfirmationInput.logReferenceID;
        this.portalTypeID = this.appointmentConfirmationInput.portalTypeID;
    }
    // #endregion

}

